import React, { useState } from 'react';
import { Fade, MenuItem, Paper, Popper } from '@mui/material';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import { useClickOutside } from '@src/hooks/useClickOutSide';

import { StyledIconButton } from './index.style';

const Actions = ({ handleOpenDeleteDialog }) => {
  const { t } = useTranslation();
  const [anchorBlockOption, setAnchorBlockOption] = useState(null);
  const [openPopperBlockOption, setOpenPopperBlockOption] = useState(false);

  const refClickOutSide = useClickOutside(() => {
    setOpenPopperBlockOption(false);
  });

  const popperStyles = {
    zIndex: 1000,
    width: '180px',
    color: '#1E164E',
  };

  const menuItemStyles = {
    color: '#1E164E',
    fontSize: '14px',
    height: '40px',
    boxSizing: 'border-box',
    padding: '10px 16px 10px 16px',
    fontWeight: 500,
  };

  const deleteIconStyles = {
    color: '#FF3B30',
    fontSize: '24px',
  };

  return (
    <>
      <div ref={refClickOutSide}>
        <StyledIconButton
          data-id="view-other-project-actions"
          height="40px"
          width="40px"
          padding="12px"
          onClick={(e) => {
            e.stopPropagation();
            setOpenPopperBlockOption(!openPopperBlockOption);
            setAnchorBlockOption(e.currentTarget);
          }}
        >
          <MoreVertOutlinedIcon
            className="icon-morevert"
            color="rgba(30, 22, 78, 0.64)"
          />
        </StyledIconButton>
      </div>
      <Popper
        transition
        style={popperStyles}
        anchorEl={anchorBlockOption}
        open={openPopperBlockOption}
        placement="bottom-start"
      >
        {({ TransitionProps }) => (
          <Fade
            style={{
              padding: '4px 0px',
              boxShadow: '0px 0px 20px 2px rgba(0, 0, 0, 0.1)',
            }}
            {...TransitionProps}
            timeout={350}
          >
            <Paper>
              <MenuItem
                key="handleOpenDeleteBlock"
                style={menuItemStyles}
                onClick={(e) => {
                  e.stopPropagation();
                  handleOpenDeleteDialog();
                }}
              >
                <DeleteIcon style={deleteIconStyles} />
                <span>{t('deleteProject')}</span>
              </MenuItem>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
};

export default Actions;
